export enum BroadcastEventEnum {
    clientInitialized = '.client.initialized'
}
